"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.StyledInput = exports.InputWrapper = void 0;
var react_1 = __importStar(require("react"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var react_places_autocomplete_1 = require("react-places-autocomplete");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../");
/**
 * A styled wrapper for an input component.
 *
 * @component
 * @param {Object} props - The props object for the component.
 * @param {boolean} [props.extLabel=false] - Whether the label is outside of the input field or not.
 * @returns {JSX.Element} A styled wrapper for an input component.
 */
exports.InputWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-bottom: ", ";\n"], ["\n  position: relative;\n  margin-bottom: ", ";\n"])), function (props) { return (props.extLabel ? "1rem" : "2rem"); });
/**
 * A styled input component.
 *
 * @component
 * @param {Object} props - The props object for the component.
 * @param {boolean} [props.border=true] - Whether the input field has a border or not.
 * @returns {JSX.Element} A styled input component.
 */
exports.StyledInput = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: ", ";\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  transition: border 0.2s;\n  &:focus {\n    outline: none;\n    border: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: ", ";\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  transition: border 0.2s;\n  &:focus {\n    outline: none;\n    border: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.fontSize; }, function (props) { return props.theme.color; }, function (props) { return props.theme.white; }, function (props) { return (props.border ? props.theme.border : "none"); }, function (props) { return (props.border ? props.theme.borderFocused : "none"); }, function (props) { return props.theme.grey; });
/**
 * A styled label component.
 *
 * @component
 * @param {Object} props - The props object for the component.
 * @param {boolean} props.hasValue - Whether the input field has a value or not.
 * @returns {JSX.Element} A styled label component.
 */
exports.StyledLabel = styled_components_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 1rem;\n  top: ", ";\n  font-size: ", ";\n  color: ", ";\n  transform: ", ";\n  transition: transform 0.2s, font-size 0.2s, top 0.2s;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 1rem;\n  top: ", ";\n  font-size: ", ";\n  color: ", ";\n  transform: ", ";\n  transition: transform 0.2s, font-size 0.2s, top 0.2s;\n  pointer-events: none;\n"])), function (props) { return (props.hasValue ? "-1 .5rem" : "50%"); }, function (props) { return (props.hasValue ? "0.8rem" : "inherit"); }, function (props) { return props.theme.grey; }, function (props) {
    return props.hasValue ? "translateY(0)" : "translateY(-50%)";
});
/**
 * A styled input component that can be used for various purposes.
 *
 * @component
 * @example
 * ```jsx
 * <Input
 *   label="Username"
 *   state={username}
 *   setState={setUsername}
 *   placeholder="Enter your username"
 *   locked={true}
 *   warning={true}
 *   warningMessage="Changing the value is not recommended at this stage."
 * />
 * ```
 *
 * @param {InputProps} props - The props object for the component.
 * @returns {JSX.Element} A styled input component.
 */
var AddressInput = function (props) {
    var theme = (0, __1.useEloise)().theme;
    var _a = __assign(__assign({}, theme.input), props), label = _a.label, extLabel = _a.extLabel, border = _a.border, state = _a.state, setState = _a.setState, placeholder = _a.placeholder, type = _a.type, onEnter = _a.onEnter, locked = _a.locked, warning = _a.warning, warningMessage = _a.warningMessage, style = _a.style, rounded = _a.rounded, addy = _a.addy, cacheKey = _a.cacheKey;
    var _b = (0, react_1.useState)(false), hasValue = _b[0], setHasValue = _b[1];
    var _c = (0, react_1.useState)(false), showWarningModal = _c[0], setShowWarningModal = _c[1];
    var inputRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (addy && window.google) {
            var autocomplete_1 = new window.google.maps.places.Autocomplete(inputRef.current);
            autocomplete_1.addListener("place_changed", function () {
                var place = autocomplete_1.getPlace();
                if (place && place.formatted_address) {
                    handleAddySelect(place.formatted_address);
                }
            });
        }
    }, [addy]);
    (0, react_1.useEffect)(function () {
        setHasValue(state !== "");
    }, [state]);
    var handleAddySelect = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var results, latLng, addressComponents, street, city, state, i, types, addy;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, react_places_autocomplete_1.geocodeByAddress)(address)];
                case 1:
                    results = _a.sent();
                    return [4 /*yield*/, (0, react_places_autocomplete_1.getLatLng)(results[0])];
                case 2:
                    latLng = _a.sent();
                    addressComponents = results[0].address_components;
                    street = "";
                    city = "";
                    state = "";
                    for (i = 0; i < addressComponents.length; i++) {
                        types = addressComponents[i].types;
                        if (types.includes("street_number")) {
                            street += addressComponents[i].long_name;
                        }
                        if (types.includes("route")) {
                            street += " " + addressComponents[i].long_name;
                        }
                        if (types.includes("locality")) {
                            city = addressComponents[i].long_name;
                        }
                        if (types.includes("administrative_area_level_1")) {
                            state = addressComponents[i].short_name;
                        }
                    }
                    addy = {
                        street: street,
                        city: city,
                        state: state,
                        lat: latLng.lat,
                        lng: latLng.lng,
                    };
                    setState(addy);
                    return [2 /*return*/];
            }
        });
    }); };
    var getDisplayValue = function () {
        if (state && typeof state === "object") {
            if (state.street) {
                return state.street;
            }
            else if (state.city) {
                return state.city;
            }
        }
        return state || ""; // Return an empty string if state is null or undefined
    };
    var handleCloseModal = function () { return setShowWarningModal(false); };
    var handleInputChange = function (e) {
        if (locked || warning) {
            setShowWarningModal(true);
        }
        else {
            setState(e.target.value);
        }
    };
    var handleInputBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!state) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleAddySelect(state)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (state !== "")
            setHasValue(true);
    }, [state]);
    (0, react_1.useEffect)(function () {
        if (cacheKey !== undefined) {
            var cachedValue = localStorage.getItem(cacheKey);
            if (cachedValue !== null) {
                setState(cachedValue);
            }
        }
    }, [cacheKey]);
    (0, react_1.useEffect)(function () {
        if (cacheKey !== undefined) {
            localStorage.setItem(cacheKey, state);
        }
        return function () {
            if (cacheKey !== undefined) {
                localStorage.removeItem(cacheKey);
            }
        };
    }, [cacheKey, state]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.InputWrapper, { extLabel: extLabel },
            extLabel && react_1.default.createElement(exports.StyledLabel, { hasValue: hasValue }, label),
            react_1.default.createElement(exports.StyledInput, { ref: inputRef, border: border, value: getDisplayValue(), onChange: handleInputChange, onBlur: handleInputBlur, placeholder: !extLabel ? placeholder : undefined, type: type, readOnly: locked, style: __assign(__assign({}, style), { borderRadius: rounded ? theme.borderRadius : 0 }) })),
        react_1.default.createElement(Modal_1.default, { show: showWarningModal, onHide: handleCloseModal, centered: true },
            react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
                react_1.default.createElement(Modal_1.default.Title, null, "Warning")),
            react_1.default.createElement(Modal_1.default.Body, null, warningMessage),
            react_1.default.createElement(Modal_1.default.Footer, null,
                react_1.default.createElement("button", { className: "btn btn-primary", onClick: handleCloseModal }, "Close")))));
};
var RegularInput = function (props) {
    var theme = (0, __1.useEloise)().theme;
    var _a = __assign(__assign({}, theme.input), props), label = _a.label, extLabel = _a.extLabel, border = _a.border, state = _a.state, setState = _a.setState, placeholder = _a.placeholder, type = _a.type, onEnter = _a.onEnter, locked = _a.locked, warning = _a.warning, warningMessage = _a.warningMessage, style = _a.style, rounded = _a.rounded, addy = _a.addy, cacheKey = _a.cacheKey;
    var _b = (0, react_1.useState)(false), hasValue = _b[0], setHasValue = _b[1];
    var _c = (0, react_1.useState)(false), showWarningModal = _c[0], setShowWarningModal = _c[1];
    var inputRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        setHasValue(state !== "");
    }, [state]);
    var handleCloseModal = function () { return setShowWarningModal(false); };
    var handleInputChange = function (e) {
        if (locked || warning) {
            setShowWarningModal(true);
        }
        else {
            setState(e.target.value);
        }
    };
    (0, react_1.useEffect)(function () {
        if (cacheKey !== undefined) {
            var cachedValue = localStorage.getItem(cacheKey);
            if (cachedValue !== null) {
                setState(cachedValue);
            }
        }
    }, [cacheKey]);
    (0, react_1.useEffect)(function () {
        if (cacheKey !== undefined) {
            localStorage.setItem(cacheKey, state);
        }
        return function () {
            if (cacheKey !== undefined) {
                localStorage.removeItem(cacheKey);
            }
        };
    }, [cacheKey, state]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.InputWrapper, { extLabel: extLabel },
            extLabel && react_1.default.createElement(exports.StyledLabel, { hasValue: hasValue }, label),
            react_1.default.createElement(exports.StyledInput, { ref: inputRef, border: border, value: state, onChange: handleInputChange, placeholder: !extLabel ? placeholder : undefined, type: type, readOnly: locked, style: __assign(__assign({}, style), { borderRadius: rounded ? "3px" : 0 }) })),
        react_1.default.createElement(Modal_1.default, { show: showWarningModal, onHide: handleCloseModal, centered: true },
            react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
                react_1.default.createElement(Modal_1.default.Title, null, "Warning")),
            react_1.default.createElement(Modal_1.default.Body, null, warningMessage),
            react_1.default.createElement(Modal_1.default.Footer, null,
                react_1.default.createElement("button", { className: "btn btn-primary", onClick: handleCloseModal }, "Close")))));
};
var Input = function (props) {
    var addy = props.addy;
    if (addy) {
        return react_1.default.createElement(AddressInput, __assign({}, props));
    }
    return react_1.default.createElement(RegularInput, __assign({}, props));
};
exports.default = Input;
var templateObject_1, templateObject_2, templateObject_3;
